import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useFav } from "@/context/FavoritesContext";
import ProductCard from "@/components/ProductCard";
import api from "@/lib/api";
import { useState } from "react";

export default function Favorites() {
  const { ids } = useFav();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    if (!ids.length) { setProducts([]); return; }
    api.get("/products", { params: { limit: 200 } }).then(({ data }) => {
      setProducts(data.products.filter((p) => ids.includes(p.id)));
    });
  }, [ids]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-14">
      <h1 className="font-display text-4xl lg:text-5xl font-light mb-10">Mes favoris</h1>
      {products.length === 0 ? (
        <div className="py-20 text-center">
          <p className="text-neutral-500">Aucun favori pour l'instant.</p>
          <Link to="/catalogue" className="btn btn-dark mt-6">Parcourir la galerie</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 lg:gap-x-8">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
